import {v4 as uuid} from 'uuid';
import {mxResources} from './mxGraphFactory';

const graphStartTaskFromGeometry = (startTaskName, tasks, childIndex, geometry) => {
    const startTaskRoute = geometry?.routes?.find(route =>
        route.targetTask === startTaskName &&
        !tasks.some(task => task.name === route.sourceTask)
    );

    if (startTaskRoute) {
        return {
            id: uuid(),
            name: startTaskRoute.sourceTask,
            splitType: 'Or',
            geometry: geometry?.tasks?.[`${childIndex}::${startTaskRoute.sourceTask}`],
            startRoute: startTaskRoute
        };
    }

    const startTaskPlaceholderName = mxResources.get('start');
    if (tasks.some(task => task.name === startTaskPlaceholderName)) {
        return null;
    }

    const geometryTask = geometry?.tasks?.[`${childIndex}::${startTaskPlaceholderName}`];
    if (!geometryTask) {
        return null;
    }

    return {
        id: uuid(),
        name: startTaskPlaceholderName,
        splitType: 'Or',
        geometry: geometryTask
    };
};

const findStartTask = (startTaskId, tasks, routes, childIndex, geometry) => {
    const logicalStartTask = tasks.find(task => task.id === startTaskId);
    if (logicalStartTask?.style === 'start') {
        return logicalStartTask;
    }

    const startRoute = routes.find(route => route.target === startTaskId && route.source !== startTaskId);
    const routedStartTask = startRoute ? tasks.find(task => task.id === startRoute.source) : null;
    if (routedStartTask?.style === 'start') {
        return routedStartTask;
    }

    const geometryStartTask = graphStartTaskFromGeometry(logicalStartTask?.name || tasks[0]?.name, tasks, childIndex, geometry);
    if (geometryStartTask) {
        return geometryStartTask;
    }

    return {
        id: uuid(),
        name: mxResources.get('start'),
        splitType: 'Or'
    };
};

export {
    findStartTask
};
